import { Component } from '@angular/core';
import { ProductImageZoomDialogComponent } from "@spartacus/product/image-zoom/components";
import { ICON_TYPE } from '@spartacus/storefront';


@Component({
  selector: 'cx-product-image-zoom-dialog',
  templateUrl: 'custom-product-image-zoom-dialog.component.html',
  styleUrls: ['custom-product-image-zoom-dialog.component.scss'],
  standalone: false
})
export class CustomProductImageZoomDialogComponent extends ProductImageZoomDialogComponent {
  iconTypes = ICON_TYPE;

  close(reason = ''): void {
    this.launchDialogService.closeDialog(reason)
  }
}
